import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { TbFilterOff, TbSearch } from "react-icons/tb";

export const AuditEventsFilter = ({
  filterParams,
  setFilterParams,
  applyFilters,
  loading,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      applyFilters();
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          label="Идентификатор на реф. објект"
          fullWidth
          variant="outlined"
          size="small"
          value={filterParams.relId || ""}
          onChange={(e) =>
            setFilterParams({ ...filterParams, relId: e.target.value })
          }
          onKeyDown={handleKeyDown}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          label="Корисничко име"
          fullWidth
          variant="outlined"
          size="small"
          value={filterParams.username || ""}
          onChange={(e) =>
            setFilterParams({ ...filterParams, username: e.target.value })
          }
          onKeyDown={handleKeyDown}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={2} lg={2}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ padding: "7px 0", mt: "1px" }}
          onClick={() => {
            applyFilters();
          }}
          startIcon={<TbSearch />}
        >
          {!loading ? (
            <Typography className="login-button-text">Пребарај</Typography>
          ) : (
            <CircularProgress size={20} id="circular-progress" />
          )}
        </Button>
      </Grid>
      <Grid item xs={12} sm={4} md={1.5} lg={1.5}>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          sx={{ padding: "5px 0", mt: "1px" }}
          startIcon={<TbFilterOff style={{ color: "#ef233c" }} />}
          onClick={() => {
            setFilterParams({});
            applyFilters();
          }}
        >
          Исчисти филтри
        </Button>
      </Grid>
    </Grid>
  );
};
